// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3nRhV","file":"styles_file__ufiF5"};